import { styled } from '@nykaa/ui-components';

// constants
import { DWEB_MAX_WIDTH } from 'shared/styles/base';

export const Container = styled.main`
  width: ${DWEB_MAX_WIDTH}px;
  margin: ${({ theme }) => `${theme.spacing.spacing100} auto ${theme.spacing.spacing320}`};
  max-width: 100%;

  &:focus {
    outline: none;
  }
  &:focus-visible {
    outline: none;
  }
`;
